<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img
          class="solutionDetailTitle1"
          src="../../static/images/solutionText10.png"
        />
        <br />
        <img
          class="solutionDetailTitle2"
          src="../../static/images/solutionText11.png"
        />
        <div class="solutionDetailText">
          基于民航局提出“平安、绿色、智慧、人文”为核心的“四型机场”建设目标，以智慧为牵引的发展战略，利用人工智能、大数据、物联网等新技术具有强大的赋能作用，通过搭建机场大数据平台、智能决策引擎、联合指挥平台等，构建一个全感知、全联接、全场景、全智能的数字化机场。
        </div>
        <div class="solutionDetailFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              机场陆侧交通综合信息管理平台
            </div>
            <div class="solutionDetailSecondText">
              机场综合交通管理平台是一个连接空侧航空出行旅客和陆侧地面交通运力方的平台。通过对旅客运力需求和交通资源信息的实时掌握，实现对机场综合交通中心实时客流、运力情况的实时监测；以航班数据为基础，对旅客所需交通运力进行预测，实现交通运力需求的提前感知，便于提前联动相关的运输资源，减少航延和航班高峰期旅客拥堵现象，使机场交通中心成为一个智能化、科学化、合理化的交通枢纽节点。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic18.jpg"
            />
          </div>
        </div>

        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic19.jpg"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              航站楼协同决策系统（T-CDM)
            </div>
            <div class="solutionDetailSecondText">
              航站楼协同决策系统打造一套由数据驱动的航站楼运行控制体系，其功能包含基于航站楼运行数据集成分析的大脑中枢、基于业务知识库和算法模型的运行事件预测预警、基于智能决策引擎的任务协同平台。平台通过航站楼运行状态的提前感知，主动向保障单位和旅客推送精准的信息服务，实现资源使用情况实时共享、异常事件及时预警和处置、旅客服务高效保障等。
            </div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              航空物流综合信息服务平台
            </div>
            <div class="solutionDetailSecondText">
              航空物流综合信息服务平台以大数据、物联网、移动互联网等技术为支撑，通过“互联网+”的方式，构建以航空物流全流程业务管理为核心的航空物流生态圈，形成无缝衔接上下游信息链的高效航空物流信息保障体系，打造集航空物流全链路服务、统一的航空物流在线服务、货物跟踪、智能拼单、数据交换、服务信息展示等为一体的综合服务平台。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic26.png"
            />
          </div>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail5.vue